module.exports = __webpack_public_path__ + "static/img/06.9c8ce93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-cgM/06.jpg
// module id = 94l/
// module chunks = 1